/**
 * APIエラーレスポンスから、利用者へ表示してよい短いメッセージを取り出す。
 * 取り出し順: data.message → data.detail.message → data.detail（文字列）。
 * 見つからない場合は null（呼び出し側で固定文にフォールバックする）。
 */
const pickText = (v: unknown): string | null =>
  typeof v === 'string' && v.trim() !== '' ? v.trim() : null;

export const extractApiErrorMessage = (err: unknown): string | null => {
  const data = (err as { response?: { data?: unknown } } | null)?.response?.data;
  if (!data || typeof data !== 'object') return pickText(data);

  const body = data as { message?: unknown; detail?: unknown };
  const detail = body.detail;
  const detailMessage =
    detail && typeof detail === 'object' && !Array.isArray(detail)
      ? pickText((detail as { message?: unknown }).message)
      : pickText(detail);

  return pickText(body.message) ?? detailMessage;
};
